import {
  configLoad,
  myDetailLoad,
  matchSignLoad,
  myInfoLoad,
  dkGamesLoad,
  dkCupPlayerLoad,
  dkCupPlayersLoad
} from "../../services/api";
import {
  Dialog
} from 'vant';

import {
  UPDATE_CONFIG,
  UPDATE_NOW_TIME,
  UPDATE_MY_DETAIL,
  UPDATE_MY_INFO,
  UPDATE_MY_DK_GAMES,
  UPDATE_MY_DK_CUP_LAYERS,
  UPDATE_MY_ADDRESS
} from "../mutation-types";
import {
  getServerTime,
  assign,
  has,
  isString
} from "../../common/utils";
import {
  WZ
} from "../../common/globals";
import {
  HOST_WEB
} from "../../common/const";
import loadDistricts from "./address";
import addAddress from "./add-reward-info";
import  { loadMyOpenId, loadOauthAddress, goBind } from "./oauth";

// 获取用户信息
async function loadMyInfo({
  commit
}, opts) {
  return myInfoLoad({}, assign({
    cache: true
  }, opts)).then(info => {
    commit(UPDATE_MY_INFO, info)
    return info
  })
}

async function loadConfig({
  state,
  commit
}) {
  const info = await configLoad({
    cId: state.cId
  }, {
    cache: true
  })
  // console.log(JSON.stringify(info, null, 2))

  commit(UPDATE_CONFIG, info);
  // commit(UPDATE_BLOCKS, info);
  return info.configInfo
}

async function loadRealityCupId({
  getters,
  dispatch
}) {
  let realityCupId = getters.realityCupId
  if (!realityCupId) {
    const config = await dispatch('loadConfig')
    realityCupId = config.realityCupId
  }

  // commit(UPDATE_BLOCKS, info);
  return realityCupId
}


// 开启计时器
let timer = null

function timerStart(args) {
  const {
    getters,
    commit
  } = args
  const nowTime = getServerTime()
  const endTime = getters.awardTime + 3600000 * 24
  // console.log({nowTime, endTime, offset: nowTime - endTime});
  if (nowTime < endTime) {
    // interval = interval > 0 ? interval > 1000 ? interval : interval * 1000 : 1000;
    const interval = 1000
    timerStop()
    timer = setInterval(() => {
      const _now = getServerTime()
      // console.log(_now);
      if (endTime > _now) {
        commit(UPDATE_NOW_TIME)
      } else if (timer) {
        timerStop()
      }
    }, interval)
    // } else {
    // alert('已结束')
  } else {
    // console.log('ended');
  }
}

// 停止计时器
function timerStop() {
  if (timer) {
    clearInterval(timer)
  }
  timer = null
}

// 加载：我的进展
async function loadMyDetail({
  state,
  commit,
  dispatch
}, opts) {
  let {
    cId
  } = state
  if (!cId) {
    const config = await dispatch('loadConfig')
    cId = config.cId
  }

  const R = await myDetailLoad({
    cId
  }, assign({
    cache: 60000 // 默认缓存1分钟
  }, opts))
  const {
    info,
    rewardUserInfo
  } = R
  // console.log(JSON.stringify(R, null, info));
  commit(UPDATE_MY_DETAIL, R);
  commit(UPDATE_MY_ADDRESS, rewardUserInfo)
  
  // TODO: 是否要同步更新 cupPlayer ?
  return info
}

// 提交报名
async function signSubmit({
  state,
  dispatch
}) {
  // alert(state.cId)
  // 判断是否已经登录
  const r = await matchSignLoad({
    cId: state.cId
  })
  await dispatch('loadMyDetail', {
    cache: false
  })
  return r
}


// 加载：我的初赛记录
async function loadMyDkGames({
  commit
}, {
  cupId,
  uid
}) {
  const query = {
    cupId
  }
  if (uid > 0) {
    query.uid = uid
  }
  const R = await dkGamesLoad(query)
  const {
    list
  } = R

  commit(UPDATE_MY_DK_GAMES, {
    cupId,
    list
  });

  return list
}

// 加载：斗K cupPlayer
async function loadDkCupPlayer({
  // getters,
  commit
}, {
  cupId
}) {
  // uid = uid > 0 ? +uid : getters.myUid
  const R = await dkCupPlayerLoad({
    cupId
  })
  const {
    cupPlayer
  } = R

  commit(UPDATE_MY_DK_GAMES, {
    cupId,
    cupPlayer
  });

  // console.log(cupPlayer);

  return cupPlayer
}

async function loadDkCupPlayers({
  state,
  commit,
  dispatch
}) {
  let {
    cId
  } = state
  if (!cId) {
    const config = await dispatch('loadConfig')
    cId = config.cId
  }
  // uid = uid > 0 ? +uid : getters.myUid
  const R = await dkCupPlayersLoad({
    cId
  })

  const {
    list
  } = R

  // console.log(JSON.stringify(list, null, 2));

  commit(UPDATE_MY_DK_CUP_LAYERS, list);


  return list
}



function goUrl({
  state
}, url, isReplace) {
  const {
    Urls
  } = state
  if (Urls && has(Urls, url)) {
    url = Urls[url]
  }

  if (url && isString(url)) {
    if (isReplace === true) {
      location.replace(url)
    } else {
      location.href = url
    }
  }
}

async function _alertLogin(opts) {
  opts = opts || {}
  let {
    title,
    message,
    buttonText
  } = opts
  title = title || '参赛提醒'
  message = message || '<div class="ta_left">尊敬的用户您好！<br><span class="blue">验证手机号即可参与大赛</span>，同时手机号也是核实身份发放奖励的唯一凭证</div>',
    // cancelButtonText: '取消',
    buttonText = buttonText || '验证手机号参赛'
  return await Dialog.alert({
    title,
    message,
    // cancelButtonText: '取消',
    confirmButtonText: buttonText
  })
}

async function goLogin(args, url) {
  url = url || location.href
  WZ.go('login', {
    url,
    hash: 'loginMob'
  })
}

async function checkLogin({
  getters
}) {
  const {
    isValidUser
  } = getters
  if (!isValidUser) {
    return await _alertLogin()
  }
  return true
}

// 前往体验
async function goTrialDK({
  getters,
  state,
  dispatch
}) {
  // await dispatch('checkLogin')
  const {
    cId
  } = state
  const {
    isValidUser,
    experienceCupType
  } = getters
  const url = `https://${HOST_WEB}/award/klinev2/?cId=${cId}&cupType=${experienceCupType}`
  if (isValidUser) {
    location.href = url
  } else {
    await _alertLogin()
    // dispatch('goLogin', url)
    dispatch('goLogin', '')
  }
}

// 前往斗K
async function goDouK({
  getters,
  dispatch
}) {
  const {
    isValidUser
  } = getters
  const url = `https://${HOST_WEB}/award/klinev2/`
  if (isValidUser) {
    location.href = url
  } else {
    await _alertLogin()
    // dispatch('goLogin', url)
    dispatch('goLogin', '')
  }
}

// 参加预赛
async function goPrePlay({
  getters,
  state,
  dispatch
}) {
  const {
    cId
  } = state
  const {
    isValidUser,
    cupType
  } = getters

  const url = `https://${HOST_WEB}/award/klinev2/?cId=${cId}&cupType=${cupType}`
  if (isValidUser) { // 已校验手机号
    location.href = url
  } else {
    await _alertLogin()
    // dispatch('goLogin', url)
    dispatch('goLogin', '')
  }
  // alert(cupType)

}


// async function goFinalPlay({
//   getters,
//   state,
//   dispatch
// }) {
//   const {
//     cId
//   } = state
//   const {
//     isValidUser,
//     cupType
//   } = getters

//   const url = `/award/klinev2/?cId=${cId}&cupType=${cupType}`
//   if (isValidUser) { // 已校验手机号
//     location.href = url
//   } else {
//     await _alertLogin()
//     dispatch('goLogin', url)
//   }
//   // alert(cupType)

// }

export default {
  loadConfig,
  loadRealityCupId,
  loadMyInfo,
  loadMyDetail,

  // loadDkXxxx
  loadMyDkGames,
  loadDkCupPlayer,
  loadDkCupPlayers,

  loadDistricts,
  addAddress,

  // oauth
  loadMyOpenId,
  loadOauthAddress,
  goBind,

  signSubmit,
  timerStart,
  timerStop,

  checkLogin,

  goLogin,
  goPrePlay,
  goTrialDK,
  goDouK,

  goUrl
}
